module.exports = __webpack_public_path__ + "img/map_legend_color.5751adc4.svg";